import { LoaderFunction } from 'react-router';

export const loader: LoaderFunction = async () => {};
